module.exports = __webpack_public_path__ + "9bd77f36df9057eef4019cec75e6d932.svg";